<template>
  <div v-if="userInfo" class="bgff">
    <div class="um">
      <!-- <div class="um-bg-img">
        <img src="../../assets/images/userbg2.jpg" />
      </div> -->
      <div class="um-header">
        <div class="um-header-conf-pic">
          <img class="um-header-conf-img" v-lazy="setpic()" />
        </div>
        <div class="um-header-icons">
          <div class="um-header-icons-icon" @click="goto('/idealindex')">
            <van-icon
              class="main-list-icon-right"
              :size="26"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="email"
            />
          </div>
          <div class="um-header-icons-icon" @click="goto('/set')">
            <van-icon
              class="main-list-icon-right"
              :size="26"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="icon-test"
            />
          </div>
          <div class="um-header-icons-icon icon-right" @click="goto('/upgradeactive')">
            <van-icon
              class="main-list-icon-right"
              :size="26"
              :color="$abctheme.basecolor"
              name="gift-o"
            />
          </div>
           
          <div class="um-header-icons-icon icon-right" @click="generate">
            <van-icon
              class="main-list-icon-right"
              :size="26"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="ico"
            />
          </div>
        </div>
        <div class="um-myinfo">
          <div class="um-myinfo-tit">{{ userInfo.dealerName }}</div>
          <!-- <div class="um-myinfo-smtit">完善个人资料</div> -->
        </div>
        <div class="um-vipcard">
          <div class="um-vipcard-xinfo">
            <div class="um-vipcard-pic">
              <img v-lazy="$baseurl + userInfo.memberLevelModel.imgPath" />
            </div>
            <div class="um-vipcard-tit" v-if="usercoursedto">
              {{ usercoursedto.levelName }}
            </div>
            <div @click="autolev" v-if="usercoursedto.needrefCount>0&& usercoursedto.needrefCount==usercoursedto.refCount">点击可自动升级</div>
            <div v-else class="um-vipcard-smtit">{{ needstr }}</div>
          </div>
          <div class="um-vipcard-finfo" @click="nav('referralrewardrecord')">
            <van-icon
              class="um-vipcard-icon-2"
              :size="26"
              :color="$abctheme.basecolor"
              name="gold-coin-o"
            />
            <div class="um-vipcard-tit">返利小金库</div>
            <div class="um-vipcard-smtit">返利赚取记录</div>
          </div>
        </div>
        <div class="um-points">
          <div class="um-points-moleft" @click="tz('/mywallet', '0')">
            <div class="um-points-smtit">大货余额</div>
            <div class="um-points-tit">{{ userInfo.largeLoans }}</div>
          </div>
          <div class="um-points-moright" @click="tz('/mywallet', '1')">
            <div class="um-points-smtit">物料余额</div>
            <div class="um-points-tit">{{ userInfo.accessoriesLoans }}</div>
          </div>
           <div class="sttx-wz" v-if="userInfo.memberLevelModel.isTop" @click="goto('/TeamPerformanceDetail')">
              <div class="sttx-wzs">
                <!-- <div>团队年销售额：<span class="sttx-wzs-price">{{userInfo.yearTeamPerformanceAward||"0.00"}}</span></div> -->
                <div>团队当月销售额：<span class="sttx-wzs-price">{{userInfo.monthTeamPerformanceAward||"0.00"}}</span></div>
                <div>个人当月销售额：<span class="sttx-wzs-price">{{userInfo.monthPersonalPerformanceAward||"0.00"}}</span><span v-if="nextteamaward" style="font-size:14px;font-weight:blod;">(奖励:<span class="sttx-wzs-price">{{nextteamaward.awardMoney}}</span>)</span></div>
              </div>
          </div>
          <div  class="stcontent-tit" :style="{'background-color':$abctheme.basecolor,color:'#fff'}" v-if="userInfo.memberLevelModel.isTop&&nextteamaward&&!nextteamaward.isTop">
                当前团队奖励比例：<span class="f-bd">{{nextteamaward.rewardPercentage}}%</span>，距离下一个目标再努力：<span class="f-bd">￥{{nextteamaward.nextTeamMoney}}</span>
          </div>
          <div v-if="!userInfo.memberLevelModel.isTop" class="stcontent-tit" :style="{'background-color':$abctheme.basecolor,color:'#fff'}">
            团队销售奖励为董事专属奖励,您当前不享有该奖励
          </div>
          <!-- <div>在2020/09/26之前累计所需积分即可晋级</div> -->
          <div class="um-points-step">
            <van-steps
              :active-color="$abctheme.basecolor"
              :active="usercoursedto.memberLevelSelectId"
              v-if="
                usercoursedto &&
                usercoursedto.memberLevelList &&
                usercoursedto.memberLevelList.length > 0
              "
            >
              <van-step
                v-for="(item, index) in usercoursedto.memberLevelList"
                :key="index"
              >
                <div>{{ item.name }}</div>
              </van-step>
            </van-steps>
          </div>
        </div>
      </div>
      <div class="um-order">
        <div class="um-order-ztit">
          <div class="um-order-ztit-left">全部订单</div>
          <div class="um-order-ztit-right" @click="goto('/user/order', 0)">
            <div>查看全部</div>
            <van-icon
              class="main-list-icon-left"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
        </div>
        <div class="um-order-mian">
          <div class="um-order-mian-conf" @click="goto('/user/order', 1)">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="daifukuan"
            />
            <div>待付款</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="TradeCount && TradeCount.waitPayCount > 0"
              type="danger"
              >{{ TradeCount.waitPayCount }}</van-tag
            >
          </div>
          <div class="um-order-mian-conf" @click="goto('/user/order', 2)">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="daifahuo"
            />
            <div>待发货</div>
            <van-tag
              class="um-order-mian-conf-tag"
              v-if="TradeCount && TradeCount.waitSendCount > 0"
              round
              type="danger"
              >{{ TradeCount.waitSendCount }}</van-tag
            >
          </div>
          <div class="um-order-mian-conf" @click="goto('/user/order', 3)">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="yifahuo"
            />
            <div>已发货</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="TradeCount && TradeCount.waitReceiveCount > 0"
              type="danger"
              >{{ TradeCount.waitReceiveCount }}</van-tag
            >
          </div>
          <div class="um-order-mian-conf" @click="goto('/user/order', 4)">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="dingdan"
            />
            <div>已签收</div>
            <!-- <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="TradeCount && TradeCount.waitEvaluteCount > 0"
              type="danger"
              >{{ TradeCount.waitEvaluteCount }}</van-tag
            > -->
          </div>
        </div>
      </div>

      <div class="um-tranfer">
        <div class="um-tranfer-list" @click="goto('/cloundorder')">
          <div class="um-tranfer-icon">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="wulianwang-"
            />
          </div>
          <div class="um-tranfer-wz">云微商管理</div>
          <van-tag
            class="um-order-mian-conf-tag-c"
            round
            v-if="clouddealTradeCount"
            type="danger"
            >{{ clouddealTradeCount }}</van-tag
          >
        </div>
        <div class="um-tranfer-list" @click="goto('/gmclound')">
          <div class="um-tranfer-icon">
            <van-icon
              class="um-order-mian-conf-icon"
              :size="34"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="yunjisuan-"
            />
          </div>
          <div class="um-tranfer-wz">云微商返利</div>
        </div>
      </div>

      <div class="um-btns">
        <div class="um-btns-btn" @click="goto('/myrechargerecord')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="danju"
          />
          <div>充值单据</div>
        </div>
        <div class="um-btns-btn" @click="goto('/subrechargerecord')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="shenhe"
          />
          <div>下级充值审核</div>
          <van-tag
            class="um-btns-btn-tag"
            v-if="SubRechargeRecordCount"
            round
            type="danger"
            >{{ SubRechargeRecordCount }}</van-tag
          >
        </div>
        <div class="um-btns-btn" @click="goto('/teamagent')">
          <van-icon
            class="um-btns-btnf-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="daili"
          />
          <div>团队代理</div>
        </div>
        <div class="um-btns-btn" @click="applyUp">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="iconfont_-"
          />
          <div>申请升级</div>
        </div>
        <div class="um-btns-btn" @click="authorizedinvitation">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="yaoqing"
          />
          <div>授权邀请</div>
        </div>
        <div class="um-btns-btn" @click="goto('/usercfa')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="zhengshu"
          />
          <div>授权证书</div>
        </div>
        <div class="um-btns-btn" @click="goto('/diffhalflist')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="shouquanshenhe"
          />
          <div>下级半价订单</div>
        </div>
        <div class="um-btns-btn" @click="gotopingheng('/phoneteamsale','销售奖励为董事专属奖励,您当前不该享有该奖励')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="shouquanshenhe"
          />
          <div>销售奖励</div>
        </div>
         <div class="um-btns-btn" @click="goto('/RedPaper')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
             class-prefix="abc-icon"
            :color="$abctheme.basecolor"
            name="hongbao"
          />
          <div>红包雨</div>
        </div>
        <!-- <div class="um-btns-btn" @click="goto('/diffprice')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="shouquanshenhe"
          />
          <div>销售差价</div>
        </div> -->
        <div class="um-btns-btn" @click="goto('/earnestmoney')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            name="gold-coin-o"
          />
          <div>保证金</div>
        </div>
        <div class="um-btns-btn" @click="goto('/investcard')">
          <van-icon
            class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            name="gold-coin-o"
          />
          <div>充值奖励</div>
        </div>
          <div class="um-btns-btn" @click="goto('/user/coupon/list')">
          <van-icon
            :size="jsize"
            :color="$abctheme.basecolor"
            name="point-gift-o"
          />
          <div>优惠券</div>
        </div>
        <div class="um-btns-btn" @click="goto('/newdrawlottery')">
          <van-icon
            :size="jsize"
            :color="$abctheme.basecolor"
            slot="icon" 
            name="point-gift-o"
          />
          <div>抽奖</div>
        </div>
        <div class="um-btns-btn" @click="goto('/drawlotterycard')">
          <van-icon
            :size="jsize"
            :color="$abctheme.basecolor"
            slot="icon" 
            name="gift-o"
          />
          <div>我的奖品</div>
        </div>
        <!-- <div class="um-btns-btn" @click="goto('/mproductlist')">
          <van-icon
             class="um-btns-btn-icon"
            :size="jsize"
            :color="$abctheme.basecolor"
            class-prefix="abc-icon"
            name="yijianfankui"
          />
          <div>品牌馆</div>
        </div> -->
        <div class="um-btns-center" :style="{'background-color':$abctheme.basecolor}" @click="logout">
          <div>
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              color="white"
              class-prefix="abc-icon"
              name="tuichu"
            />退出登录
          </div>
        </div>
        <!-- <div class="um-btns-btn">
                <van-icon class="um-btns-btn-icon" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="dingdan" />
                <div>设置</div>
            </div> -->
      </div>
    </div>
    <navigate />
    <van-dialog
      :show-confirm-button="false"
      :show-cancel-button="false"
      closeOnClickOverlay
      v-model="showfenxiangtu"
      title=""
      width="330px"
    >
      <img style="width: 330px;" :src="$baseurl + showfenxiangtuQrcode" />
    </van-dialog>
  </div>
</template>

<script>
import Util from "../../config/Util";
import request from "@/config/ajax";
export default {
  data() {
    return {
      active: 2,
      jsize: 25,
      images: [
        "https://img.yzcdn.cn/vant/apple-1.jpg",
        "https://img.yzcdn.cn/vant/apple-2.jpg",
      ],
      userInfo: undefined,
      nextteamaward:undefined,
      levellist: [],
      TradeCount: {},
      usercoursedto: {},
      levelstart: [],
      needstr: "无升级条件",
      showfenxiangtu: false,
      showfenxiangtuQrcode: "",
      clouddealTradeCount: 0,
      SubRechargeRecordCount: 0,
    };
  },
  created: function () {
    //去登录
    if (!this.abp.userInfo) {
      this.$router.push({
        path: "/login/password",
      });
      return;
    }
    setTimeout(() => {
      this.initWx();
    }, 500);
    request.post("/api/services/app/PhoneUser/QueryUserInfo").then((x) => {
      this.userInfo = x.result;
      this.abp.userInfo = x.result;
      if(this.userInfo.memberLevelModel.isTop)
      {
          request.post("/api/services/app/PhoneUser/QueryNextMemberTeam").then((x) => {
            this.nextteamaward = x.result;
            console.log("打印参数"+this.nextteamaward);
          });
      }
    });

    request.post("/api/services/app/PhoneUser/QueryUserCourse").then((x) => {
      this.usercoursedto = x.result;
      this.needstr = this.usercoursedto.showCourseName;
    });

    this.ajax
      .post("/api/services/app/PhoneUser/QuerySubRechargeRecordPages", {
        isAudit: 0,
        sorting: "",
        maxResultCount: 1,
        skipCount: 0,
      })
      .then((x) => {
        this.SubRechargeRecordCount = x.result.totalCount;
      });
    // this.ajax
    //   .post("/api/services/app/PhoneTrade/QueryOrder", {
    //     tid: "",
    //     name: "",
    //     sku: "",
    //     tranferState: 1,
    //     productSku: "",
    //     sorting: "",
    //     maxResultCount: 1,
    //     refundStatus: 0,
    //     skipCount: 0,
    //   })
    //   .then((x) => {
    //     this.clouddealTradeCount = x.result.totalCount;
    //     this.ajax
    //       .post("/api/services/app/PhoneTrade/QueryOrder", {
    //         tid: "",
    //         name: "",
    //         sku: "",
    //         tranferState: 2,
    //         productSku: "",
    //         sorting: "",
    //         maxResultCount: 1,
    //         refundStatus: 0,
    //         skipCount: 0,
    //       })
    //       .then((p) => {
    //         this.clouddealTradeCount += p.result.totalCount;
    //         this.$forceUpdate();
    //       });
    //   });

    this.gettotal();
    //获取当前所有等级
    //重新获取用户信息
  },
  mounted() {},
  methods: {
    logout() {
      this.abp.auth.clearToken();
      //localStorage.clear();
      location.reload();
    },
    autolev(){
         this.ajax.post("/api/services/app/PhoneUser/AutoUpLev").then((x) => {
           this.$toast.success('升级成功,如需查看效果请手动刷新页面');
        });
    },
    setpic() {
      var cururl = this.$baseurl;
      if (this.userInfo.headPic) {
        if (this.userInfo.headPic.indexOf("thirdwx.qlogo.cn") != -1) {
          return this.userInfo.headPic;
        }
        return cururl + this.userInfo.headPic;
      }
      if (this.userInfo.memberLevelModel.imgPath) {
        return cururl + this.userInfo.memberLevelModel.imgPath;
      }
      return "../../assets/images/missing-face.png";
    },
    goto(url, state) {
      if (state) {
        this.$router.push({
          path: url,
          query: {
            state: state,
          },
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    tz(url, ctype) {
      if (ctype) {
        this.$router.push({
          path: url,
          query: {
            ctype: ctype,
          },
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    applyUp() {
      if (this.userInfo.memberLevelModel.isTop) {
        this.$toast.fail("您已是最高级别");
        return;
      }
      this.isfirstrecharge(()=>{
          this.$router.push({
        name: "applyupgrade",
      });
      });
      
    },
    isfirstrecharge(e){
        if (!this.userInfo.isFirstRecharge) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "您还未完成首充,点击确定前往充值页面",
          })
          .then(() => {
            this.$router.push({
              name: "rechargemoney",
              query: {
                rechargeType: 0,
              },
            });
          })
          .catch(()=>{
              e();
          });
        return;
      }else{
          e();
      }
    },
    authorizedinvitation() {
      this.isfirstrecharge(()=>{
          this.$router.push({
        name: "authorizedinvitation",
      });
      })
      
    },
    generate() {
      
      this.isfirstrecharge(()=>{
           this.showfenxiangtu = true;
      if (!this.showfenxiangtuQrcode) {
        this.ajax.post("/api/services/app/PhoneUser/MyFenXiangImg").then((x) => {
          this.showfenxiangtuQrcode = x.result;
        });
      }
      })
     

      // this.$router.push({
      //     path: "/mynvitationqrcode",
      //     query: {
      //         registMethod: 0,
      //         levelId: 0
      //     },
      // });
    },
    gettotal() {
      request.post("/api/services/app/PhoneTrade/QueryUserTradeCount").then((x) => {
        this.TradeCount = x.result;
        this.clouddealTradeCount=this.TradeCount.clouddealTradeCount;
        this.$set(this,'clouddealTradeCount',this.TradeCount.clouddealTradeCount)
      });
    },
    nav() {
      this.$router.push({
        name: "referralreward",
      });
    },
    gotopingheng(path,errmsg="动平衡分红为董事专属奖励,您当前不该享有该奖励")
    {
      //动平衡分红为董事专属奖励,您当前不该享有该奖励
      //销售奖励为董事专属奖励,您当前不该享有该奖励
      //
      if(!this.userInfo.memberLevelModel.isTop)
      {
        this.$dialog.alert({title:errmsg});
      }else
      {
          this.goto(path);
      }
    },
    initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
          var h5info = y.result;
          var wx = window.wx;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: h5info.appid, // 必填，公众号的唯一标识
            timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
            nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
            signature: h5info.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareWeibo",
              "scanQRCode",
            ], // 必填，需要使用的JS接口列表
          });
          let link = "http://" + location.host;
          wx.ready(() => {
            wx.updateAppMessageShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              desc: this.abp.systemconfig.shareDesc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                //alert(res);
              },
            });
            wx.updateTimelineShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                //alert(res);
              },
            });
          });
          wx.error(function (res) {
            //alert(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        });
    },
  },
  watch: {
    // userInfo(newvalue)
    // {
    //     if(newvalue&&newvalue.memberLevelModel&&this.levellist.length>0)
    //     {
    //           for(var i=0;i<this.levellist.length;i++)
    //           {
    //                 if(this.levellist[i].id==newvalue.memberLevelModel.id)
    //                 {
    //                     this.active=i;
    //                 }
    //           }
    //     }
    // },
    // levellist(newvalue)
    // {
    //     if(this.userInfo&&this.userInfo.memberLevelModel&&newvalue.length>0)
    //     {
    //           for(var i=0;i<newvalue.length;i++)
    //           {
    //                 if(newvalue[i].id==this.userInfo.memberLevelModel.id)
    //                 {
    //                     this.active=i;
    //                 }
    //           }
    //     }
    // }
  },
};
</script>

<style lang="scss" scoped>
.bgff{
  background:url(../../assets/images/userbg2.jpg) no-repeat;
  background-size: 100% 100%;
  
}
.um {
  margin: 0px 20px 20px 20px;
  padding-top: 70px;
  font-size: 12px;
}

.um-bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: -1;
  
  // overflow: hidden;
}

.um-bg-img img {
  width: 100%;
  height: 980px;
}

.um-header {
  background-color: #fff;
  padding: 0 10px 20px 10px;
  position: relative;
  margin-bottom: 10px;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #d2d2d2;
}

.um-header-conf-pic {
  position: absolute;
  top: -53px;
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 50%;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: white;
}

.um-header-conf-pic img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.um-header-icons {
  margin-top: 20px;
}

.um-header-icons-icon {
  display: inline-block;
  margin-right: 12px;
  margin-top: 5px;
}

.um-header-icons-icon:last-child {
  margin-right: 0;
  float: right;
}

.um-myinfo {
  margin-top: 20px;
  text-align: center;
  margin-bottom: 15px;
}

.um-myinfo-tit {
  font-size: 22px;
  margin-bottom: 5px;
}

.um-myinfo-smtit {
  display: inline;
  border-radius: 18px;
  padding: 3px 7px 3px 7px;
  font-size: 11px;
  background-color: beige;
}

.um-vipcard {
  margin-bottom: 10px;
}

.um-vipcard-xinfo {
  display: inline-block;
  border-right: 1px solid #dadada;
  padding-right: 14px;
  position: relative;
  min-width: 120px;
  padding: 0 5px 0 40px;
}

.um-vipcard-finfo {
  display: inline-block;
  position: relative;
  padding-left: 32px;
}

/* .um-vipcard-icon-1
    {
      position:absolute;
      left: 4px;
    } */

.um-vipcard-pic {
  width: 35px;
  height: 35px;
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translate(0, -50%);
}

.um-vipcard-pic img {
  width: 100%;
  height: 100%;
}

.um-vipcard-pic1 {
  width: 26px;
  height: 26px;
  position: absolute;
  left: 14px;
}

.um-vipcard-pic1 img {
  width: 100%;
  height: 100%;
}

.um-vipcard-icon-2 {
  position: absolute;
  left: 4px;
}

.um-vipcard-smtit {
  font-size: 11px;
}

.um-vipcard-tit {
  font-size: 14px;
  font-weight: bold;
}

.um-points {
  background-color: #e6e6e6;
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 10px;
}

.um-points-moleft {
  display: inline-block;
  width: 45%;
}

.um-points-moright {
  display: inline-block;
}

.um-points-smtit {
  color: #388300;
  font-size: 13px;
  font-weight: bold;
}

.um-points-tit {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
  letter-spacing: 1px;
}

.um-points-step {
  margin-top: 10px;
}

.um-order {
  background-color: #fff;
  padding: 10px;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 4px #d2d2d2;
}

.um-order-ztit {
  position: relative;
  margin-bottom: 10px;
}

.um-order-ztit-left {
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
}

.um-order-ztit-right {
  position: absolute;
  right: 0;
  top: 4px;
}

.um-order-ztit-right > div {
  display: inline-block;
}

.um-order-mian-conf {
  display: inline-block;
  width: 25%;
  position: relative;
  text-align: center;
}

.um-order-mian-conf-tag {
  position: absolute;
  top: 0;
  right: 15px;
}
.um-order-mian-conf-tag-c {
  top: -50px;
  right: -42px;
  float: left;
}
.um-btns {
  background-color: #fff;
  padding: 10px;
  text-align: left;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #d2d2d2;
}

.um-btns-btn {
  display: inline-block;
  width: 33%;
  text-align: center;
  margin-top: 12px;
}

.um-btns-center {
  width: 90px;
  background-color: #fdd108;
  border-radius: 30px;
  padding: 5px;
  text-align: center;
  margin: 15px auto 5px;
  color: white;
}

.um-btns-btn-icon {
  margin-right: 5px;
}

.um-tranfer {
  text-align: center;
  background-color: white;
  margin: 10px 0px;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 1px 1px 4px #d0cccc;
}

.um-tranfer-list {
  display: inline-block;
  margin-right: 30px;
  margin-left: 30px;
}
.um-btns-btn-tag {
  float: left;
  top: -49px;
  left: 60px;
}
.sttx-wz{
    line-height: 18px;
    background-color: #e6e6e6;
    padding-left: 0px;
    padding-top: 3px;
    word-break: break-all;
    text-align: left;
    border-radius: 4px;
}
.sttx-wzs
{
   padding-bottom: 4px;
}
.sttx-wzs-price{
  font-size: 16px;
  font-weight: bold;
}
.stcontent-tit
{
  border-radius: 4px;
  background-color: #B2C9C5;
  padding: 5px;
  font-size: 13px;
  word-break: break-all;
}
</style>
